(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"]) return;
  try {
    
  (function () {
    const container = document.querySelector('.hero-container');
    if (!container) return;
    const slider = container.querySelector('.hero-slider');
    const dots = container.querySelectorAll('.hero-dot-button');
    if (!slider || !dots.length) return;
    let autoplayInterval;

    const updateDots = () => {
      const slideWidth = slider.clientWidth;
      const currentIndex = Math.round(slider.scrollLeft / slideWidth);

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    };

    const startAutoplay = () => {
      stopAutoplay(); // Ensure no multiple intervals are running
      autoplayInterval = setInterval(() => {
        const slideWidth = slider.clientWidth;
        const currentIndex = Math.round(slider.scrollLeft / slideWidth);
        const nextIndex = (currentIndex + 1) % dots.length;

        slider.scrollTo({
          left: nextIndex * slideWidth,
          behavior: 'smooth',
        });
      }, 10000); // 10 seconds
    };

    const stopAutoplay = () => clearInterval(autoplayInterval);

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        stopAutoplay(); // Stop autoplay when user interacts
        const slideIndex = parseInt(dot.dataset.slideIndex, 10);
        const slideWidth = slider.clientWidth;
        slider.scrollTo({
          left: slideIndex * slideWidth,
          behavior: 'smooth',
        });
      });
    });

    slider.addEventListener('scroll', updateDots, { passive: true });
    // Restart autoplay on manual scroll end if needed, but for now let's keep it simple.
    // A click on a dot stops it. A manual swipe will also stop it.
    slider.addEventListener('pointerdown', stopAutoplay);

    updateDots(); // Set initial active dot
    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const container = document.querySelector('.product-images-container');
  if (container) {
    const slider = container.querySelector('.product-images');
    const prevButton = container.querySelector('.slider-button--prev');
    const nextButton = container.querySelector('.slider-button--next');

    if (slider && prevButton && nextButton) {
      const updateButtonState = () => {
        const atStart = slider.scrollLeft < 1;
        const atEnd = Math.ceil(slider.scrollLeft + slider.clientWidth) >= slider.scrollWidth;

        prevButton.disabled = atStart;
        nextButton.disabled = atEnd;
      };

      slider.addEventListener('scroll', updateButtonState, { passive: true });
      // Initial state
      updateButtonState();

      nextButton.addEventListener('click', () => {
        slider.scrollBy({ left: slider.clientWidth, behavior: 'smooth' });
      });

      prevButton.addEventListener('click', () => {
        slider.scrollBy({ left: -slider.clientWidth, behavior: 'smooth' });
      });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
